(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-einstant/assets/javascripts/lobby/all-games/all-games.js') >= 0) return;  svs.modules.push('/modules/tickets-einstant/assets/javascripts/lobby/all-games/all-games.js');
"use strict";


const {
  useEffect,
  useState,
  useContext,
  useRef
} = React;
const {
  GridCol,
  GridRow
} = svs.ui.ReactGrid;
const {
  GameGrid
} = svs.eInstant.shared;
const {
  useHistory
} = ReactRouterDOM;
const Icon = svs.ui.ReactIcon;
const {
  ROUTES: {
    ALL_GAMES,
    LOBBY
  },
  getSortOptionById,
  sortIds: {
    ALPHABETICAL
  }
} = svs.eInstant.constants;
const AllGames = () => {
  var _getSortOptionById;
  const {
    InfoOverlay,
    SortGames,
    Background
  } = svs.eInstant.shared.components;
  const history = useHistory();
  const {
    update
  } = svs.eInstant.shared.hooks.useMetaTags();
  const {
    state: {
      gameUrl
    }
  } = useContext(svs.eInstant.store.RouterContext);
  const ScrollToTop = svs.eInstant.components.ScrollToTop;
  const fetchAllGames = svs.eInstant.shared.util.fetchAllGames;
  const [selected, setSelected] = svs.eInstant.shared.hooks.useLocalStorage(ALL_GAMES.replace('/', ''), 'tickets-einstant-sort-games', ALPHABETICAL, 60);
  const [games, setGames] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const loaderRef = useRef();
  const sortFn = (_getSortOptionById = getSortOptionById(selected)) === null || _getSortOptionById === void 0 ? void 0 : _getSortOptionById.sortFn;
  useEffect(() => {
    const sortedGames = sortFn === null || sortFn === void 0 ? void 0 : sortFn([...games]);
    sortedGames && setGames(sortedGames);
  }, [selected]);
  useEffect(() => {
    !gameUrl && update(ALL_GAMES);
  }, [gameUrl]);
  useEffect(() => {
    let loader;
    if (loading && loaderRef.current) {
      loader = new svs.ui.Loader(loaderRef.current, {
        delayedShow: false
      }).show(300);
    }
    fetchAllGames().then(games => setGames((sortFn === null || sortFn === void 0 ? void 0 : sortFn([...games])) || games)).catch(() => setError(true)).finally(() => {
      setLoading(false);
      if (loader) {
        loader.hide();
      }
    });
  }, []);
  useEffect(() => {
    if (error) {
      const dialog = new svs.ui.dialog.Confirm({
        branding: svs.ui.dialog.branding.TUR,
        type: svs.ui.dialog.type.ERROR,
        title: 'Kunde inte hämta spel',
        message: [{
          type: svs.ui.dialog.message.TEXT,
          text: 'Försök igen senare eller kontakta kundservice.'
        }],
        actions: [{
          title: 'Okej',
          callback: () => {
            dialog.close();
            history.push(LOBBY);
          }
        }]
      });
      svs.ui.dialog.api.add(dialog);
    }
  }, [error, history, LOBBY]);
  const routeUrl = "".concat(svs.core.data.baseUrl).concat(ALL_GAMES);
  return React.createElement(Background, null, React.createElement(InfoOverlay, {
    onCloseUrl: routeUrl
  }), React.createElement(ScrollToTop, null), React.createElement("div", {
    className: "tickets-einstant-max-width w100"
  }, React.createElement("div", {
    className: "u-flex u-flex-column margin-v-2 margin-h-1"
  }, React.createElement(GridRow, {
    className: "u-flex u-flex-align-items-center",
    gutter: "0"
  }, React.createElement(GridCol, {
    am: 8,
    lg: 10,
    md: 8,
    xs: 12
  }, React.createElement("div", {
    className: "tickets-einstant-special-width-header"
  }, React.createElement("div", {
    className: "u-flex u-flex-column margin-top-1"
  }, React.createElement("div", {
    className: "f-body u-flex u-flex-row u-flex-align-items-center margin-bottom-2"
  }, React.createElement(Icon, {
    color: "fc-fler-lotter-new-700 margin-right-half",
    icon: "all-card-games",
    size: 500
  }), React.createElement("h1", {
    className: "h1 fc-fler-lotter-new-700 margin-0"
  }, "Alla spel"))))), React.createElement(GridCol, {
    am: 4,
    className: "tickets-einstant-margin-left-auto",
    lg: 2,
    md: 4,
    xs: 12
  }, React.createElement(SortGames, {
    hideDefault: true,
    placeholderLabel: "Sortera",
    selected: selected,
    setSelected: setSelected
  }))), React.createElement("div", {
    className: "margin-top-1-half"
  }, loading ? React.createElement("div", {
    className: "relative align-center margin-v-3 tickets-einstant-loader",
    ref: loaderRef
  }) : error ? React.createElement("div", {
    className: "u-flex u-flex-justify-content-center margin-v-3"
  }, React.createElement("h4", {
    className: "h4 fc-fler-lotter-new-700"
  }, "Ett fel uppstod vid laddning av alla spel.")) : React.createElement(GameGrid, {
    games: games
  })))));
};
setGlobal('svs.eInstant.lobby.AllGames', AllGames);

 })(window);